import { render, staticRenderFns } from "./UpcomingEvent.vue?vue&type=template&id=4a2519cc"
import script from "./UpcomingEvent.vue?vue&type=script&lang=js"
export * from "./UpcomingEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports